import React, {useState} from "react";
import {signin} from "../api/authApi";
import LoginForm from "./LoginForm";
import "./login.css";
import {PopupSpinner} from "shared/ui/popupSpinner";
import {AxiosError} from "axios";
import {useNavigate} from "react-router-dom";
import {useToast} from "shared/ui";
import {getApiErrorMsg} from "shared/lib/fns";
import {ConfirmCodeApiResponse} from "features/login/types";
import {TApiError} from "shared/types";
import {useAuth} from "features/login/context/AuthProvider";

const LoginScreen = () => {
  const navigate = useNavigate();
  const {error: showErrorToast} = useToast();
  const {login} = useAuth();
  
  const [loading, setLoading] = useState(false);
  
  const handleSignin = (username: string, password: string) => {
    setLoading(true);
    signin(username, password, onPhoneVerified, onError);
  };
  
  const onError = (error: AxiosError<TApiError>) => {
    showErrorToast(getApiErrorMsg(error));
    setLoading(false);
  };
  
  const onPhoneVerified = async (data: ConfirmCodeApiResponse) => {
    try {
      await login(data);
      navigate("/box/plan");
    } catch (error) {
      showErrorToast(getApiErrorMsg(error as AxiosError<TApiError>));
    } finally {
      setLoading(false);
    }
  };
  
  return (<div className={"login"}>
    <LoginForm onSignin={handleSignin} />
    {loading && <PopupSpinner />}
  </div>);
};

export default LoginScreen;
